import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'common'
import { RootState } from 'store'

export const usePreventRefreshDuringOrder = (): void => {
  const processingOrder = useSelector(
    (state: RootState) => state.ui.processingOrder
  )

  const message = Translate(
    'yourOrderIsBeingProcessedLeavingMayResultInDuplicateOrders'
  )

  useEffect(() => {
    if (!processingOrder) return undefined

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = message // NOSONAR
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [processingOrder, message])
}
